import React from 'react';
import { Table } from 'react-bootstrap';
import PlayWord from './PlayWord';
import $ from 'jquery';
const MP3_URL_OF_WORD = 'https://api.dictionaryapi.dev/api/v2/entries/en/';

/* 单词输入/结果显示行 */
class WordRow extends React.Component {
  constructor(props) {
    super(props);
    this.handleWordInputChange = this.handleWordInputChange.bind(this);
  }

  handleWordInputChange(event) {
    this.props.onWordInputChange(event);
  }

  play(event) {
    event.preventDefault();
    var id = event.target.id;
    var audio = document.getElementById(id+'_audio');
    audio.play();
  }

  render() {
    const word = this.props.word;
    const answer = this.props.answer;
    const answered = this.props.answered;
    const isRight = word.english.trim() === answer.trim();
    const irregular = word.is_irregular ? '不规则动词，过去式: ' + word.past_tense +',过去分词: ' + word.past_participle + '.' : '';
    if (answered){
      return( 
        <tr className="border_bottom">
          <td>{word.chinese}
	        {word.has_mp3?(<PlayWord src={URL+'media/mp3/'+word.english+'.mp3'} />):''}
          </td>
          <td>{isRight ? (<span>{answer}</span>) : (<span style={{"color":"red"}}>{answer}</span>)}</td>
          <td><a href={"http://dict.cn/"+word.english} target="_blank">{word.english}</a></td>
          <td>{isRight ? (<span style={{"color":"green"}}>✓</span>) : (<span style={{"color":"red"}}>✗</span> )}</td><td>{irregular}</td>
        </tr>
      )
    } else {
      return( 
        <tr className="border_bottom">
          <td>{word.chinese}
	        {word.has_mp3?(<PlayWord src={URL+'media/mp3/'+word.english+'.mp3'} />):''}
          </td>
          <td><input ref="hahaha" type="text" id={word.id} onChange={this.handleWordInputChange} /></td>
        </tr>
      )
    }
  }
}

/* 单词输入表 */
class WordTable extends React.Component {
  constructor(props) {
    super(props);
    this.handleWordInputChange = this.handleWordInputChange.bind(this);
  }

  handleWordInputChange(event) {
    this.props.onWordInputChange(event);
  }

  render() {
    const rows = [];
    const test_words = this.props.test_words;
    const answers = this.props.answers;
    const answered = this.props.answered;
    /* 生成单词列表 */
    if (test_words.length>0) {
      var i = 1; // ref
      test_words.forEach((word) =>{
        var answer = (answers.find(x=>x.id===word.id)) ? answers.find(x=>x.id===word.id).answer : '';
        if (word.is_main){
          rows.push(<WordRow reff={i} answered={answered} word={word} key={word.id} answer={answer} onWordInputChange={this.handleWordInputChange} />)
        }
      })
      /* 生成表头 */
      const header = answered ? (<tr className="border_bottom"><th>中文</th><th>输入单词</th><th>正确答案</th><th>结果</th><th>说明</th></tr>):(<tr className="border_bottom"><th>中文</th><th>输入单词</th></tr>)
      return (<Table striped hover><thead>{header}</thead><tbody>{rows}</tbody></Table>)
    } else {
      return <div><p>请选择年级、单元。</p></div>
    }
  }
}

export default WordTable;



// WEBPACK FOOTER //
// ./src/Test_WordTable.js